import { types } from "../actions";

const initialState = {
  message: null,
  status: null,
  errorType: null,
  hasLicenseForbiddenError: false,
  roleError: null,
  notificationKey: 0,
};

const errorReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FORBIDDEN_ERROR_OCCURRED":
      return {
        ...state,
        message: action.payload,
        status: 403,
      };
    case "CLEAR_ERROR_MESSAGE":
      return {
        ...state,
        message: null,
        status: null,
        errorType: null,
      };
    case types.SET_ERROR:
      return {
        ...state,
        message: action.payload.message,
        // status: action.payload.status || state.status,
        errorType: action.payload.errorType,
        notificationKey: state.notificationKey + 1,
      };
    case types.SET_LICENSE_FORBIDDEN_ERROR:
      return {
        ...state,
        hasLicenseForbiddenError: action.payload,
      };
    case types.SET_ROLE_ERROR:
      return {
        ...state,
        roleError: action.payload,
      };
    default:
      return state;
  }
};

export default errorReducer;
